import { useState } from 'react';
import { Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { useLogin } from '../auth';
import { LabeledField } from '../components/LabeledField';
import { Note } from '../components/Note';
import { DISPLAY, MONO, tokens } from '../theme';

/**
 * Màn đăng nhập.
 *
 * Cố ý KHÔNG có link "quên mật khẩu": chưa có SMTP nội bộ nên không gửi được mail
 * đặt lại. Hiện admin đặt lại hộ, và câu đó nói thẳng ra cho người dùng biết phải
 * làm gì thay vì để họ bấm vào một link không hoạt động.
 */
export function LoginPage() {
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const canSubmit = email.trim().length > 0 && password.length > 0 && !login.isPending;

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!canSubmit) return;
    login.mutate({ email: email.trim().toLowerCase(), password });
  }

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        bgcolor: 'background.default',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        py: 6,
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 400 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 3 }}>
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: '9px',
              bgcolor: tokens.mint,
              color: tokens.ink,
              display: 'grid',
              placeItems: 'center',
              fontWeight: 700,
              fontSize: 15,
            }}
          >
            AI
          </Box>
          <Box>
            <Typography sx={{ fontFamily: DISPLAY, fontSize: 19, fontWeight: 700, color: tokens.ink }}>
              SEO Copilot
            </Typography>
            <Typography sx={{ fontFamily: MONO, fontSize: 11.5, color: 'text.secondary' }}>
              SPLUS SOFTWARE
            </Typography>
          </Box>
        </Stack>

        <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 3.5 } }}>
          <Typography sx={{ fontFamily: DISPLAY, fontSize: 20, fontWeight: 600, color: tokens.ink }}>
            Đăng nhập
          </Typography>
          <Typography sx={{ fontSize: 13.5, color: 'text.secondary', mt: 0.5, mb: 2.5 }}>
            Dùng tài khoản do quản trị hệ thống cấp.
          </Typography>

          <Stack component="form" spacing={2} onSubmit={submit}>
            <LabeledField
              label="Email"
              type="email"
              autoComplete="username"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <LabeledField
              label="Mật khẩu"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {login.isError && <Note tone="bad">{(login.error as Error).message}</Note>}

            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={!canSubmit}
              startIcon={login.isPending ? <CircularProgress size={16} color="inherit" /> : undefined}
            >
              {login.isPending ? 'Đang kiểm tra…' : 'Đăng nhập'}
            </Button>
          </Stack>
        </Paper>

        <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mt: 2, textAlign: 'center' }}>
          Quên mật khẩu thì nhờ quản trị hệ thống đặt lại — hệ thống chưa gửi được email.
        </Typography>
      </Box>
    </Box>
  );
}
